<template>
    <div class="integrityResult">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <div class="centerTab">
            <div><img src="../../assets/img/index/CXGheader.png" alt=""></div>
            <div class="menuTab">
                <div class="top">
                    <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                </div>
            </div>
        </div>
        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div><img src="../../assets/img/index/title4.png" alt="" style="margin: 10px auto 0;"></div>
                    <div><img src="../../assets/img/index/division2.png" alt="" style="margin: 0 auto;width: 100%;"></div>
                    <div class="evaluate">
                        <div class="left">
                            <!-- <h4>评价信息</h4> -->
                            <div><i>姓名: </i>{{detail.name}}</div>
                            <div><i>职务: </i>{{detail.gender}}</div>
                            <div><i>出生年月: </i>{{detail.date}}</div>
                            <div><i>身份证号码: </i>{{detail.Idcard}}</div>
                            <div><i>职业名称: </i>{{detail.duties}}</div>
                            <div><i>单位名称: </i>{{detail.workUnit}}</div>
                            <div><i>证书编号: </i>{{detail.code}}</div>
                            <div><i>评定成绩: </i>{{detail.grade}}</div>
                            <div><i>发证日期: </i>{{detail.publishTime}}</div>
                            <div><i>简介: </i><div v-html="detail.content"></div></div>
                        </div>
                        <div class="right">
                            <div>
                                <img :src="baseUrl + detail.peopleImg" alt="" v-if="detail.peopleImg">
                                <span v-else>上传照片</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'integrityResult',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            baseUrl: baseURL,
            menuTabList: [
                {
                    name: '首页',
                    title: '企业诚信官',
                    url: '/integrity'
                },
                {
                    name: '培训动态',
                    title: '培训动态',
                    url: '/integrity_list'
                },
                // {
                //     name: '新闻图片',
                //     title: '新闻图片',
                //     url: '/integrity_list'
                // },
                {
                    name: '活动通知',
                    title: '活动通知',
                    url: '/integrity_list'
                },
                {
                    name: '政策文件',
                    title: '政策文件',
                    url: '/integrity_list'
                },
                {
                    name: '优秀学员',
                    title: '优秀学员',
                    url: '/goodStudents'
                },
                {
                    name: '证书查询',
                    title: '证书查询',
                    url: ''
                },
                {
                    name: '师资介绍',
                    title: '师资介绍',
                    url: '/integrity_search'
                },
                {
                    name: '培训课程',
                    title: '培训课程',
                    url: '/integrity_list'
                },
                {
                    name: '推荐图书',
                    title: '推荐图书',
                    url: '/integrity_list'
                },
            ],
            detail: {
                // name: '韩家平',
                // gender: '男',
                // code: '911101026662879416',
                // birthday: '2023-09-07',
                // Idcard: '326765190405232323',
                // job: 'HR',
                // id: '911101026662879416',
                // certificate: '2023-09-11'
            }
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle

        this.getPersonInfo(this.$route.query.id)
    },
    mounted() {
    },
    methods: {
        // 获取详情
        getPersonInfo(id) {
            let _this = this
            _this.loading = true
            let params = {
                id: id
            }
            api.getPersonInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.detail = data.data
                    _this.loading = false
                } else {
                    _this.loading = false
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
                    _this.loading = false
            })
        },

        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },
    }
}
</script>

<style lang="less" scoped>
.integrityResult {
    position: relative;
    padding-bottom: 140px;
    .centerTab {
            width: 80%;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
            margin: 0 auto;
            padding: 0 50px;
            margin-top: 10px;
            .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 20px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
        }
    .main {
        width: 80%;
            @media only screen and (min-width: 769px) {
                min-width: 1152px;
            }
        padding: 15px 50px;
        margin: 0 auto;
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 800px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px 50px 50px;
                background: url('../../assets/img/index/watermark.png') no-repeat;
                background-position-x: center;
                .evaluate {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    /* padding: 0 300px; */
                    .left {
                        font-size: 18px;
                        color: #666;
                        width: 60%;
                        h4 {
                            font-size: 22px;
                            font-weight: 700;
                            margin-bottom: 15px;
                            color: #333;
                        }
                        i {
                            color: #1A68E8;
                            padding-right: 2px;
                        }
                    }
                    .right {
                        position: relative;
                        border: 1px solid #D9D9D9;
                        background-color: #fff;
                        width: 248px;
                        height: 165px;
                        cursor: pointer;
                        img {
                            width: 248px;
                            height: 165px;
                            object-fit: contain;
                        }
                        span {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            border: 1px solid #1A68E8;
                            color: #1A68E8;
                            padding: 5px 9px;
                        }
                    }
                }
                .cont {
                    display: flex;
                    justify-content: left;
                    /* padding: 0 300px; */
                    .left {
                        font-size: 18px;
                        color: #666;
                        h4 {
                            font-size: 22px;
                            font-weight: 700;
                            margin-bottom: 15px;
                            color: #333;
                        }
                        i {
                            color: #1A68E8;
                            padding-right: 2px;
                        }
                    }
                }
            }
        }
    }
}
</style>

